import moment from 'moment-timezone';

const MEXICO_TIMEZONE = 'America/Mexico_City';

export const isProgrammingDateExpired = (programmingDate) => {
  if (!programmingDate) return true;

  const parsed = moment(programmingDate);
  if (!parsed.isValid()) return true;

  // Get current time in Mexico timezone
  const nowInMexico = moment().tz(MEXICO_TIMEZONE);

  // Convert programming date to Mexico timezone
  const dateInMexico = parsed.tz(MEXICO_TIMEZONE, true);

  // If programming date <= now in Mexico -> expired
  return dateInMexico.isSameOrBefore(nowInMexico);
};

// Display status of the scheduled date in the campaigns table.
export const getProgrammingDateDisplay = (fechaProgramacion, estado) => {
  if (fechaProgramacion) return { type: 'scheduled', date: new Date(fechaProgramacion) };
  if (estado === 'PENDING') return { type: 'pending' };
  return { type: 'empty' };
};

// Default value for the scheduling picker: next full minute, always in the future.
export const getDefaultScheduledDate = (now = new Date()) => {
  const next = new Date(now);
  next.setSeconds(0, 0);
  next.setMinutes(next.getMinutes() + 1);
  return next;
};

export const formatDateTime = (date) => {
  if (!date) return '';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} - ${hours}:${minutes}`;
};

export const formatApiDate = (date) => {
  if (!date) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};


export const addSeconds = (date, seconds) => {
  const newDate = new Date(date);
  newDate.setSeconds(newDate.getSeconds() + seconds);
  return newDate;
};


export const addMinutes = (date, minutes) => {
  const newDate = new Date(date);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  return newDate;
};


export const isSameDay = (date1, date2) => {
  if (!date1 || !date2) return false;
  
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

export const getMinCampaignSendDateTime = (now = new Date()) => {
  return now;
};

export const isValidCampaignSendDateTime = (selectedDateTime) => {
  return !!selectedDateTime;
};


//filters
export const formatFilterDate = (date) => {
  if (!date) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

export const addDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

export const resetTime = (date) => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};